export default __webpack_public_path__ + "static/media/participateIcon1.816f996a.png";